import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiFormControl-root': {
    backgroundColor: '#ffffff',
  },
  '& .MuiFormLabel-root.MuiInputLabel-root': {
    paddingLeft: 8,
    paddingRight: 8,
    backgroundImage: 'linear-gradient(to bottom, transparent 50%, #fff 50%)',
    color: '#666666',
    '&.Mui-error': {
      color: '#F14C2E',
    },
  },
  '& .MuiFormControl-root.MuiTextField-root .MuiOutlinedInput-root.Mui-focused fieldset': {
    borderColor: '#00b5e299',
    borderWidth: 2,
  },
  '& .MuiFormControl-root.MuiTextField-root .MuiOutlinedInput-root fieldset': {
    borderWidth: '1px',
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
  '& .Mui-error': {
    '& fieldset': {
      borderColor: '#F14C2E !important',
    },
  },
}));
